import React from "react";
import { useRef } from "react";
import { useEffect } from "react";

function DivisionDesignation({
  position,
  validationError,
  handleChangeDesignationName,
  division,
  setShowDescription,
  handleUpdateDesignation,
  handleShowDescription,
  handleSetEditDesignation,
  handleDeleteDesignation,
  showDescription,
  hasDesignationPermission,
}) {
  const designationRef = useRef();

  useEffect(() => {
    if (designationRef.current) {
      designationRef.current.style.height = "100%";
      const scrollHeight = designationRef.current.scrollHeight;
      designationRef.current.style.height = scrollHeight + "px";
    }
  }, [position]);

  return (
    <li>
      <div
        className={
          !validationError?.level && validationError?.id === position.id
            ? "add-to-list-input-wrapper unit-error-border"
            : "add-to-list-input-wrapper"
        }
      >
        <textarea
          ref={designationRef}
          autoFocus
          rows="1"
          style={{ resize: "none", overflow: "hidden" }}
          readOnly={!position.typing && !position.editing}
          type="text"
          className="add-to-list-input"
          value={position?.name}
          onChange={(e) =>
            handleChangeDesignationName(
              e,
              position.id,
              division.id,
              "divisions",
              "name"
            )
          }
          // onKeyDown={(e) =>
          //   handleKeyDown(e, handleAddConfirmPositionToDepartment, department.id, position.id)
          // }
          // onBlur={() => {
          //   position.name
          //     ? handleAddConfirmPositionToDepartment(department.id, position.id)
          //     : handleDeletePositionFromDepartment(department.id, position.id);
          // }}
        ></textarea>

        <div className="edit-buttons-block">
          {(position?.typing || position.editing) && position?.name && (
            <button
              onClick={() => {
                setShowDescription(null);
                handleUpdateDesignation({
                  ...position,
                  level: 2,
                });
              }}
            >
              <img src="/images/check1.jpg" />
            </button>
          )}
          {!position?.typing &&
            !position.editing &&
            position?.name &&
            hasDesignationPermission && (
              <button
                onClick={() => {
                  handleShowDescription(position.id, 2, true);
                  handleSetEditDesignation(
                    position.id,
                    division.id,
                    "divisions",
                    2
                  );
                }}
              >
                <img src="/images/edit.png" />
              </button>
            )}
          {hasDesignationPermission && (
            <button
              onClick={() =>
                handleDeleteDesignation(
                  { id: position.id, level: 2 },
                  "designation"
                )
              }
            >
              <img src="/images/trash.png" />
            </button>
          )}
          {!position.adding && (
            <button onClick={() => handleShowDescription(position.id, 2)}>
              <img
                alt=""
                src={
                  showDescription && showDescription.id === position.id
                    ? "/images/iks.png"
                    : "/images/plus.png"
                }
              />
            </button>
          )}
        </div>
      </div>
      {showDescription && showDescription.id === position.id && (
        <textarea
          rows="4"
          cols="50"
          className="position-description"
          value={position.description || ""}
          readOnly={!position.editing}
          onChange={(e) =>
            handleChangeDesignationName(
              e,
              position.id,
              division.id,
              "divisions",
              "description"
            )
          }
        />
      )}
    </li>
  );
}

export default DivisionDesignation;
